const NexusDataActions = require("../../actions/metadata/NexusDataActions.js");

const NexusData = require("../../types/metadata/NexusData.js");

function getUpdatedSpec(originalState, specUpdate) {
    const newSpecData = Object.assign({}, NexusData.GetSpecData(), specUpdate);

    const update = Object.assign({}, originalState.Metadata, {
        CurrentSpec: Object.assign({}, originalState.Metadata.CurrentSpec, {
            Data: newSpecData
        })
    });

    return Object.assign({}, originalState, {
        Metadata: update
    });
}

function getCurrentTargets(originalState) {
    return Object.assign({}, originalState.Metadata.CurrentSpec.Data.Targets);
}

const NexusDataReducers = {
    [NexusDataActions.LoadTargets](prev, action) {
        const result = getUpdatedSpec(prev, {
            Targets: {
                Loading: true,
                Loaded: false,
                Data: [],
                Error: null
            },
            Target: null
        });

        return result;
    },
    [NexusDataActions.LoadedTargets](prev, action) {
        const orderedData = action.Data;
            //.sort((a, b) => {
            //    if (a.DisplayOrder < b.DisplayOrder) return -1;
            //    if (a.DisplayOrder > b.DisplayOrder) return 1;

            //    if (a.GLCode < b.GLCode) return -1;
            //    if (a.GLCode > b.GLCode) return 1;

            //    return 0;
            //});

        const withDefault = [
            {
                GLCode: "",
                Description: "Select an account",
                DisplayOrder: 0
            },
            ...orderedData.slice()
        ];

        const result = getUpdatedSpec(prev, {
            Targets: {
                Loading: false,
                Loaded: true,
                Data: withDefault,
                Error: null
            },
            Target: null
        });

        return result;
    },
    [NexusDataActions.LoadTargetsErrored](prev, action) {
        const result = getUpdatedSpec(prev, {
            Targets: {
                Loading: false,
                Loaded: false,
                Data: [],
                Error: action.Error
            },
            Target: null
        });

        return result;
    },
    [NexusDataActions.TargetSelected](prev, action) {
        const isComplete = action.Target && action.Target.GLCode.length > 0;
        const arg = isComplete ? JSON.stringify({ StoreNumber: action.Target.GLCode }) : null;
        
        const newSpecData = Object.assign({}, NexusData.GetSpecData(), {
            Targets: getCurrentTargets(prev),
            Target: action.Target,
            IsComplete: isComplete,
            Arg: arg
        });

        const result = getUpdatedSpec(prev, newSpecData);

        return result;
    }
};

module.exports = NexusDataReducers;


// WEBPACK FOOTER //
// ./src/reducers/metadata/NexusDataReducers.js